<template>
    <div class="dosing-page">
        <DosingMain />

        <DosingCTAcontent />
    </div>
</template>

<script>
import headers from '../models/headers';
import DosingCTAcontent from '../components/dosing/DosingCTAcontent.vue';
import DosingMain from '../components/dosing/DosingMain.vue';

export default {
    components: {
        DosingCTAcontent,
        DosingMain,
    },
    metaInfo: headers.dosingPage(),
    data() {
        return {};
    },
    methods: {},
};
</script>
